import {
    CREATE_PRODUCT_PROPERTY,
    CREATE_PRODUCT_PROPERTY_FAILURE,
    CREATE_PRODUCT_PROPERTY_SUCCESS,
} from 'store/actions/types';

// Create Product Property
export const createProductProperty = (payload) => {
    return {
        type: CREATE_PRODUCT_PROPERTY,
        payload: payload,
    };
};

export const createProductPropertyFailure = (error) => {
    return {
        type: CREATE_PRODUCT_PROPERTY_FAILURE,
        error: error,
    };
};

export const createProductPropertySuccess = (payload, response) => {
    return {
        type: CREATE_PRODUCT_PROPERTY_SUCCESS,
        payload: payload,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/productProperties/createProductProperties.js